const MedicalRecordsBt: React.FC<{
    isSelected: boolean;
    count?: number;
}> = ({ isSelected, count }) => {
    return (
        <div
            className={`menuitem ${count && count > 0 ? 'filled' : ''} ${
                isSelected ? 'selected' : ''
            }`}
        >
            <div>
                <div>
                    <svg viewBox="0 0 448 512" width="18" height="18">
                        {count && count > 0 ? (
                            <path d="M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z" />
                        ) : (
                            <path d="M433.9 98L350 14.1C341 5.1 328.8 0 316.1 0h-204c-26.5.1-48 21.6-48 48.1V288H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h126.1l34.7 69.5c2.9 5.9 11.4 5.9 14.3 0L240 275.8l22.1 44.2H352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-70.1l-34.7-69.5c-2.9-5.9-11.4-5.9-14.3 0L176 332.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H96V48.1c0-8.8 7.3-16.1 16.1-16.1h176v104.1c0 13.3 10.7 23.9 24 23.9h104v304c0 8.8-7.2 16-16 16h-288c-8.8 0-16.1-7.2-16.1-16V352H64.1v112c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V132c0-12.7-5.1-25-14.1-34zM320 128.1V32.6c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9c2.1 2.1 3.5 4.6 4.2 7.4H320z" />
                        )}
                    </svg>
                </div>
                <p>Medical Records</p>
            </div>
            <div className="flex space-x-8">
                {count && count > 0 ? (
                    <p className="p-2 min-w-20 h-24 font-700 text-12 text-white rounded-2 chip-show text-actionPrimary border border-actionPrimary text-center">
                        {count}
                    </p>
                ) : null}
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    {count && count > 0 ? (
                        <path d="M10.0547 16.8125C10.2891 17.0469 10.6875 17.0469 10.9219 16.8125L17.8125 9.92188C18.0469 9.6875 18.0469 9.28906 17.8125 9.05469L16.9688 8.21094C16.7344 7.97656 16.3594 7.97656 16.125 8.21094L10.5 13.8359L7.85156 11.2109C7.61719 10.9766 7.24219 10.9766 7.00781 11.2109L6.16406 12.0547C5.92969 12.2891 5.92969 12.6875 6.16406 12.9219L10.0547 16.8125Z"></path>
                    ) : (
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                    )}
                </svg>
            </div>
        </div>
    );
};

export default MedicalRecordsBt;
